(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-dismissible')) {
        if (this.isDismissed()) {
          this.remove();
          return;
        }

        const closeButton = this.querySelector('[data-announcement-close]');
        if (closeButton) {
          closeButton.addEventListener('click', () => this.dismiss());
        }
      }
    }

    get storageKey() {
      return `fk:announcement:${this.dataset.key || 'default'}`;
    }

    isDismissed() {
      try {
        return window.localStorage.getItem(this.storageKey) === '1';
      } catch (error) {
        return false;
      }
    }

    dismiss() {
      try {
        window.localStorage.setItem(this.storageKey, '1');
      } catch (error) {
        // Storage unavailable (private mode): dismissal just won't persist.
      }
      this.remove();
    }
  }

  if (!customElements.get('announcement-bar')) {
    customElements.define('announcement-bar', AnnouncementBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.contents = this.querySelector('#CartDrawerContents');

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });

      document.addEventListener('click', (event) => {
        if (event.target.closest('[data-cart-toggle]')) {
          event.preventDefault();
          this.open();
          return;
        }
        if (event.target.closest('[data-cart-close]')) {
          this.close();
          return;
        }
        const up = event.target.closest('[data-qty-up]');
        const down = event.target.closest('[data-qty-down]');
        const remove = event.target.closest('[data-remove]');
        const quick = event.target.closest('[data-quick-add]');
        if (up) this.changeLine(up.dataset.lineKey, this.lineQty(up.dataset.lineKey) + 1);
        else if (down) this.changeLine(down.dataset.lineKey, this.lineQty(down.dataset.lineKey) - 1);
        else if (remove) this.changeLine(remove.dataset.lineKey, 0);
        else if (quick) this.addVariant(quick.dataset.variantId);
      });

      document.addEventListener('change', (event) => {
        const input = event.target.closest('[data-qty]');
        if (input) this.changeLine(input.dataset.lineKey, parseInt(input.value, 10) || 0);
      });

      document.addEventListener('submit', (event) => {
        const form = event.target;
        if (form.matches('form') && form.action.includes('/cart/add') && event.submitter && event.submitter.name === 'add') {
          event.preventDefault();
          this.addFromForm(form);
        }
      });
    }

    open() {
      if (!this.dialog.open) this.dialog.showModal();
    }

    close() {
      if (this.dialog.open) this.dialog.close();
    }

    lineQty(key) {
      const input = document.querySelector('[data-qty][data-line-key="' + key + '"]');
      return input ? parseInt(input.value, 10) || 0 : 0;
    }

    async changeLine(key, quantity) {
      const cart = await this.postJSON('/cart/change.js', { id: key, quantity: Math.max(0, quantity) });
      this.render(cart);
    }

    async addVariant(id) {
      const cart = await this.postJSON('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
      this.render(cart);
      this.open();
    }

    async addFromForm(form) {
      const data = new FormData(form);
      data.append('sections', 'cart-drawer');
      data.append('sections_url', window.location.pathname);
      try {
        const response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        const cart = await response.json();
        this.render(cart);
        this.open();
      } catch (error) {
        form.submit();
      }
    }

    async postJSON(url, body) {
      body.sections = ['cart-drawer'];
      body.sections_url = window.location.pathname;
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      return response.json();
    }

    render(cart) {
      if (cart && cart.sections && cart.sections['cart-drawer']) {
        this.replaceContents('CartDrawerContents', cart.sections['cart-drawer']);
      }
      this.syncCount();
      this.refreshCartPage();
      if (window.FK) FK.announce(this.dataset.i18nUpdated || '');
    }

    replaceContents(id, html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = parsed.getElementById(id);
      const current = document.getElementById(id);
      if (next && current) current.innerHTML = next.innerHTML;
    }

    async refreshCartPage() {
      if (!document.getElementById('MainCartContents')) return;
      const response = await fetch(window.location.pathname, { headers: { Accept: 'text/html' } });
      const text = await response.text();
      this.replaceContents('MainCartContents', text);
    }

    syncCount() {
      const source = this.contents.querySelector('[data-cart-count]');
      const count = source ? parseInt(source.dataset.count, 10) || 0 : 0;
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = count;
        node.dataset.count = count;
        node.toggleAttribute('hidden', count === 0);
      });
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-gateway"] && !Shopify.designMode) return;
  try {
    
  // Affiliate pass-through: /pages/custom-keycaps?a=CODE forwards ?a=CODE to the
  // off-site custom project CTA so the customization app keeps the attribution.
  class AffiliateLink extends HTMLElement {
    connectedCallback() {
      const code = this.affiliateCode;
      if (!code) return;

      this.querySelectorAll('a[href]').forEach((link) => {
        try {
          const url = new URL(link.href, window.location.href);
          url.searchParams.set('a', code);
          link.href = url.toString();
        } catch (error) {
          // Unparseable href (mailto:, tel:, …): leave it alone.
        }
      });
    }

    get affiliateCode() {
      const raw = new URLSearchParams(window.location.search).get('a');
      if (!raw) return null;

      const code = raw.trim();
      // Affiliate codes are short alphanumeric tokens; ignore anything else.
      if (!/^[A-Za-z0-9_-]{1,64}$/.test(code)) return null;
      return code;
    }
  }

  if (!customElements.get('affiliate-link')) {
    customElements.define('affiliate-link', AffiliateLink);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  class CurrencySelector extends HTMLElement {
    connectedCallback() {
      this.current = this.dataset.current;
      this.form = this.querySelector('form');

      // Remember the shopper's pick so it survives Shopify's localization
      // cookie expiring between visits.
      this.addEventListener('click', (event) => {
        const option = event.target.closest('[data-currency-option]');
        if (!option) return;
        try {
          localStorage.setItem('fk-currency-country', option.value);
        } catch (error) {
          /* storage unavailable (private mode) — ignore */
        }
      });

      this.applyStored();
    }

    applyStored() {
      if (!this.form) return;

      let stored;
      try {
        stored = localStorage.getItem('fk-currency-country');
      } catch (error) {
        return;
      }
      if (!stored || stored === this.current) return;

      // Re-apply at most once per session so a server geo-override can't loop us.
      try {
        if (sessionStorage.getItem('fk-currency-applied')) return;
        sessionStorage.setItem('fk-currency-applied', '1');
      } catch (error) {
        return;
      }

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'country_code';
      input.value = stored;
      this.form.appendChild(input);
      this.form.submit();
    }
  }

  if (!customElements.get('currency-selector')) {
    customElements.define('currency-selector', CurrencySelector);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class SiteHeader extends HTMLElement {
    connectedCallback() {
      const toggle = this.querySelector('[data-nav-toggle]');
      const nav = this.querySelector('[data-nav]');

      if (toggle && nav) {
        toggle.addEventListener('click', () => {
          const open = nav.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', String(open));
        });
      }

      const desktop = window.matchMedia('(hover: hover) and (min-width: 60.0625rem)');
      const dropdowns = this.querySelectorAll('details');

      dropdowns.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (details.open) {
            dropdowns.forEach((other) => {
              if (other !== details) other.open = false;
            });
          }
        });

        details.addEventListener('mouseenter', () => {
          if (desktop.matches) details.open = true;
        });
        details.addEventListener('mouseleave', () => {
          if (desktop.matches) details.open = false;
        });

        details.addEventListener('focusout', (event) => {
          if (desktop.matches && !details.contains(event.relatedTarget)) details.open = false;
        });

        const summary = details.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', (event) => {
            if (desktop.matches && event.detail > 0) event.preventDefault();
          });
        }
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) {
          dropdowns.forEach((details) => { details.open = false; });
        }
      });
    }
  }

  if (!customElements.get('site-header')) {
    customElements.define('site-header', SiteHeader);
  }

  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.url = this.dataset.searchUrl;
      this.toggle = document.querySelector('[data-search-toggle]');
      this.panel = this.querySelector('.psearch__panel');
      this.input = this.querySelector('[data-search-input]');
      this.resultsWrap = this.querySelector('[data-predictive-results]');
      this.status = this.querySelector('[data-search-status]');
      this.backdrop = this.querySelector('[data-search-backdrop]');
      this.controller = null;
      this.debounce = null;
      this.onKeydown = this.onKeydown.bind(this);

      if (this.toggle) this.toggle.addEventListener('click', () => this.open());
      this.querySelector('[data-search-close]').addEventListener('click', () => this.close());
      this.backdrop.addEventListener('click', () => this.close());
      this.input.addEventListener('input', () => this.onInput());
    }

    open() {
      this.hidden = false;
      if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);
      if (window.FK) FK.trapFocus(this.panel, this.input);
      else this.input.focus();
    }

    close() {
      this.hidden = true;
      if (this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
      if (this.controller) this.controller.abort();
      this.classList.remove('is-loading');
      if (window.FK) FK.removeTrapFocus(this.toggle);
      else if (this.toggle) this.toggle.focus();
    }

    onInput() {
      const term = this.input.value.trim();
      clearTimeout(this.debounce);
      if (term.length < 2) {
        if (this.controller) this.controller.abort();
        this.classList.remove('is-loading');
        this.resultsWrap.innerHTML = '<div id="predictive-search-results" class="psearch__results"></div>';
        if (this.status) this.status.textContent = '';
        return;
      }
      // Show the loader immediately so the debounce + fetch gap isn't dead air.
      this.classList.add('is-loading');
      this.debounce = setTimeout(() => this.search(term), 220);
    }

    async search(term) {
      if (this.controller) this.controller.abort();
      const controller = new AbortController();
      this.controller = controller;
      const params = new URLSearchParams({
        q: term,
        section_id: 'predictive-search',
        'resources[type]': 'query,product,page,article',
        'resources[limit]': '6',
        'resources[limit_scope]': 'each',
      });
      try {
        const res = await fetch(`${this.url}?${params}`, { signal: controller.signal });
        if (!res.ok) return;
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const node = doc.querySelector('#predictive-search-results');
        if (!node) return;
        this.resultsWrap.innerHTML = node.outerHTML;
        const count = this.resultsWrap.querySelectorAll('[data-psearch-link]').length;
        if (this.status) {
          this.status.textContent = count > 0
            ? `${count} ${this.dataset.i18nResults}`
            : this.dataset.i18nNoResults;
        }
      } catch (err) {
        if (err.name !== 'AbortError') this.resultsWrap.innerHTML = '';
      } finally {
        // Only the latest (non-superseded) request clears the loader.
        if (!controller.signal.aborted) this.classList.remove('is-loading');
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }

      const links = Array.from(this.resultsWrap.querySelectorAll('[data-psearch-link]'));

      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (links.length === 0) return;
        event.preventDefault();
        const current = links.findIndex((el) => el.classList.contains('is-active'));
        let next = event.key === 'ArrowDown' ? current + 1 : current - 1;
        if (next < 0) next = links.length - 1;
        if (next >= links.length) next = 0;
        links.forEach((el) => el.classList.remove('is-active'));
        links[next].classList.add('is-active');
        links[next].scrollIntoView({ block: 'nearest' });
        return;
      }

      if (event.key === 'Enter') {
        const active = this.resultsWrap.querySelector('[data-psearch-link].is-active');
        if (active) {
          event.preventDefault();
          active.click();
        }
        return;
      }

      // Tab focus-trapping is handled by FK.trapFocus (a11y-helpers).
    }
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', PredictiveSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.hero__slide'));
      if (this.slides.length < 2) return;

      this.dots = Array.from(this.querySelectorAll('.hero__dot'));
      this.interval = parseInt(this.dataset.interval, 10) || 6000;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.wantsAutoplay = this.dataset.autoplay === 'true' && !this.reduceMotion;
      this.index = this.slides.findIndex((s) => s.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;

      const prev = this.querySelector('.hero__nav--prev');
      const next = this.querySelector('.hero__nav--next');
      if (prev) prev.addEventListener('click', () => this.step(-1, true));
      if (next) next.addEventListener('click', () => this.step(1, true));
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i, true)));

      this.addEventListener('touchstart', (e) => {
        this.touchStartX = e.changedTouches[0].screenX;
        this.touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });
      this.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].screenX - this.touchStartX;
        const dy = e.changedTouches[0].screenY - this.touchStartY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
        this.step(dx < 0 ? 1 : -1, true);
      }, { passive: true });

      this.addEventListener('mouseenter', () => this.pause());
      this.addEventListener('mouseleave', () => this.resume());
      this.addEventListener('focusin', () => this.pause());
      this.addEventListener('focusout', () => this.resume());
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
        else this.resume();
      });

      this.addEventListener('shopify:block:select', (e) => {
        const slide = e.target.closest('.hero__slide');
        const i = this.slides.indexOf(slide);
        this.editorLock = true;
        this.pause();
        if (i >= 0) this.go(i, false);
      });
      this.addEventListener('shopify:block:deselect', () => {
        this.editorLock = false;
        this.resume();
      });

      this.start();
    }

    go(target, fromUser) {
      const total = this.slides.length;
      const next = ((target % total) + total) % total;

      const current = this.slides[this.index];
      current.classList.remove('is-active');
      current.setAttribute('inert', '');
      current.setAttribute('aria-hidden', 'true');
      if (this.dots[this.index]) this.dots[this.index].removeAttribute('aria-current');

      this.index = next;
      const slide = this.slides[next];
      slide.classList.add('is-active');
      slide.removeAttribute('inert');
      slide.removeAttribute('aria-hidden');
      if (this.dots[next]) this.dots[next].setAttribute('aria-current', 'true');

      if (fromUser) this.restart();
    }

    step(direction, fromUser) {
      this.go(this.index + direction, fromUser);
    }

    start() {
      if (!this.wantsAutoplay || this.paused || this.editorLock || this.timer) return;
      this.timer = setInterval(() => this.step(1, false), this.interval);
    }

    stop() {
      clearInterval(this.timer);
      this.timer = null;
    }

    restart() {
      this.stop();
      this.start();
    }

    pause() {
      this.paused = true;
      this.stop();
    }

    resume() {
      if (this.editorLock) return;
      this.paused = false;
      this.start();
    }
  }

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  class FacetResults extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.debounce = null;
      this.controller = null;
      this.onPopState = this.onPopState.bind(this);

      this.addEventListener('change', (event) => {
        if (!event.target.closest('[data-filter-bar]')) return;
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => this.applyForm(), 400);
      });

      this.addEventListener('click', (event) => {
        const link = event.target.closest('a.filter-bar__chip, a.filter-bar__clear, a.collection__page');
        if (!link || !link.href) return;
        event.preventDefault();
        this.navigate(link.href, true);
      });

      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      window.removeEventListener('popstate', this.onPopState);
    }

    onPopState() {
      this.navigate(window.location.href, false);
    }

    applyForm() {
      const form = this.querySelector('[data-filter-bar]');
      if (!form) return;
      const params = new URLSearchParams(new FormData(form));
      this.navigate(`${window.location.pathname}?${params.toString()}`, true);
    }

    async navigate(url, push) {
      const classList = this.classList;
      classList.add('is-loading');

      const fetchUrl = new URL(url, window.location.origin);
      fetchUrl.searchParams.set('section_id', this.sectionId);

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();

      try {
        const response = await fetch(fetchUrl.toString(), { signal: this.controller.signal });
        if (!response.ok) {
          window.location.assign(url);
          return;
        }
        const text = await response.text();
        const parsed = new DOMParser().parseFromString(text, 'text/html');
        const next = parsed.querySelector('facet-results');
        if (!next) {
          window.location.assign(url);
          return;
        }

        this.innerHTML = next.innerHTML;

        const clean = new URL(url, window.location.origin);
        clean.searchParams.delete('section_id');
        const cleanUrl = clean.pathname + clean.search;
        if (push) window.history.pushState({}, '', cleanUrl);

        const count = this.querySelector('[data-result-count]');
        if (count && window.FK) FK.announce(count.textContent.trim());

        this.scrollIntoView({ block: 'start', behavior: 'smooth' });
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(url);
      } finally {
        classList.remove('is-loading');
      }
    }
  }

  if (!customElements.get('facet-results')) {
    customElements.define('facet-results', FacetResults);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-guide"]) return;
  try {
    
  class GuideArticle extends HTMLElement {
    connectedCallback() {
      const body = this.querySelector('.guide__body');
      const toc = this.querySelector('[data-toc]');
      const list = this.querySelector('[data-toc-list]');
      if (!body || !toc || !list) return;

      const headings = Array.from(body.querySelectorAll('h2[id]'));
      if (headings.length < 4) return;

      headings.forEach((heading) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        link.dataset.tocLink = heading.id;
        item.appendChild(link);
        list.appendChild(item);
      });

      toc.hidden = false;
      this.querySelector('.guide__layout').classList.add('guide__layout--toc');

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              list.querySelectorAll('a').forEach((a) => {
                a.classList.toggle('is-active', a.dataset.tocLink === entry.target.id);
              });
            }
          });
        }, { rootMargin: '0px 0px -75% 0px' });
        headings.forEach((heading) => observer.observe(heading));
      }
    }
  }

  if (!customElements.get('guide-article')) {
    customElements.define('guide-article', GuideArticle);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  (function () {
    function slugify(text) {
      return text
        .toLowerCase()
        .trim()
        .replace(/[^\w\s-]/g, '')
        .replace(/[\s_]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
    }

    function init() {
      document.querySelectorAll('.page__body').forEach(function (body) {
        body.querySelectorAll('h2, h3').forEach(function (heading) {
          if (!heading.id) {
            heading.id = slugify(heading.textContent);
          }
          if (!heading.id || heading.querySelector('.page__anchor')) {
            return;
          }

          var anchor = document.createElement('a');
          anchor.className = 'page__anchor';
          anchor.href = '#' + heading.id;
          anchor.textContent = '#';
          anchor.setAttribute('aria-label', 'Copy link to this section');

          anchor.addEventListener('click', function (event) {
            event.preventDefault();
            var url = location.origin + location.pathname + '#' + heading.id;

            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(url).then(function () {
                anchor.classList.add('is-copied');
                setTimeout(function () {
                  anchor.classList.remove('is-copied');
                }, 1500);
              }).catch(function () {});
            }
          });

          heading.insertBefore(anchor, heading.firstChild);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  class ProductForm extends HTMLElement {
    connectedCallback() {
      const dataEl = this.querySelector('[data-variant-data]');
      this.variants = dataEl ? JSON.parse(dataEl.textContent) : {};
      this.idInput = this.querySelector('[name="id"]');
      this.priceEl = document.querySelector('[data-price]');
      this.atc = this.querySelector('[data-atc]');
      this.fieldsets = Array.from(this.querySelectorAll('[data-option-position]'))
        .sort((a, b) => a.dataset.optionPosition - b.dataset.optionPosition);
      this.gallery = document.querySelector('media-gallery');

      this.addEventListener('change', () => this.update());
      this.addEventListener('click', (event) => this.step(event));
      this.observeGallery();
      this.updateAvailability();

      // Sync the gallery to the variant chosen on load (e.g. ?variant= deep link).
      const initial = this.matchVariant();
      if (initial) this.switchMedia(initial[1]);
    }

    chosenOptions() {
      return this.fieldsets.map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    matchVariant() {
      const chosen = this.chosenOptions();
      return Object.entries(this.variants).find(([, variant]) =>
        variant.options.length === chosen.length &&
        variant.options.every((value, index) => value === chosen[index])
      ) || null;
    }

    // Swap the main gallery image to the one bound to this variant, if any.
    switchMedia(variant) {
      if (!variant || variant.featured_media == null) return;
      if (this.gallery && typeof this.gallery.showMedia === 'function') {
        this.gallery.showMedia(variant.featured_media);
      }
    }

    update() {
      const chosen = this.chosenOptions();
      const match = this.matchVariant();

      this.updateAvailability();

      if (!match) {
        // No variant for this combination — block the add until a valid pick.
        if (this.atc) {
          this.atc.disabled = true;
          this.atc.textContent = this.atc.dataset.soldout;
        }
        return;
      }

      const [id, variant] = match;
      if (this.idInput) this.idInput.value = id;
      if (this.priceEl) this.priceEl.textContent = variant.price;
      this.switchMedia(variant);

      if (this.atc) {
        this.atc.disabled = !variant.available;
        this.atc.textContent = variant.available ? this.atc.dataset.add : this.atc.dataset.soldout;
      }

      const stickyVariant = document.querySelector('[data-sticky-variant]');
      if (stickyVariant) stickyVariant.textContent = chosen.filter(Boolean).join(' · ');

      const url = new URL(window.location);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url);
    }

    updateAvailability() {
      const chosen = this.chosenOptions();
      const variants = Object.values(this.variants);

      this.fieldsets.forEach((fs) => {
        const position = parseInt(fs.dataset.optionPosition, 10) - 1;
        fs.querySelectorAll('.pdp__choice-input').forEach((input) => {
          const label = input.nextElementSibling;
          const matches = variants.filter((variant) => {
            if (variant.options[position] !== input.value) return false;
            return variant.options.every((optValue, index) =>
              index === position || chosen[index] == null || chosen[index] === optValue
            );
          });
          const exists = matches.length > 0;
          const available = matches.some((variant) => variant.available);

          // Never disable the currently-selected value — only flag it sold out.
          input.disabled = input.checked ? false : !exists;
          if (label) {
            label.classList.toggle('is-unavailable', !input.checked && !exists);
            label.classList.toggle('is-soldout', exists && !available);
          }
        });
      });
    }

    step(event) {
      const button = event.target.closest('[data-step]');
      if (!button) return;
      const input = this.querySelector('[name="quantity"]');
      if (!input) return;
      const current = parseInt(input.value, 10) || 1;
      input.value = Math.max(1, current + (button.dataset.step === 'up' ? 1 : -1));
    }

    observeGallery() {
      const gallery = document.querySelector('[data-gallery]');
      const sticky = document.querySelector('[data-sticky]');
      if (!gallery || !sticky || !('IntersectionObserver' in window)) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        });
      }, { rootMargin: '0px 0px -50% 0px' });
      observer.observe(gallery);
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  } catch(e) { console.error(e); }
})();
})();
